import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import LightString, { LIGHT_SEQUENCE_DIRECTIONS } from '../gameobjects/LightString';
import MusicDialog from '../gameobjects/MusicDialog';
import Snow from '../gameobjects/Snow';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import DrawLightsInstructions from './DrawLightsInstructions';
import SelectLevel from './SelectLevel';
import LocalizationUIAssets from '../Localization-UIAssets';

export default class Decorate extends Phaser.Scene
{
    static get KEY() { return 'Decorate'; }

    constructor()
    {
        super({ key: (Decorate).KEY });
    }

    create()
    {
        this.background = ABCyaPhaser.Images.addImage(this.scale.width / 2, this.scale.height / 2, UIAssetKeys._decorate_background, this).setInteractive();

        this.background.on(Phaser.Input.Events.GAMEOBJECT_POINTER_MOVE, this.pressMove, this);
        this.background.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.pressDown, this);

        this.addBrightHouse();

        this.lightsLeftLabel = ABCyaPhaser.Text.addText(this.scale.width - 250, 5, 34, 0xffffff, FontKeys._odin_roundedregular, "", this, false);

        this.nextButton = ABCyaPhaser.Buttons.addSimpleButton(this.scale.width / 2 + 430, this.scale.height / 2 + 220, UIAssetKeys._sprites_go_button, null, () =>
        {
            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
            this.showMusicDialog();
        }, this).setScale(0.6);

        this.tweens.timeline(
            {
                tweens:
                    [
                        ABCyaPhaser.Tweens.createTween(this.nextButton, 500, { scale: 1, offset: 100 }, Phaser.Math.Easing.Quadratic.Out),
                        ABCyaPhaser.Tweens.createTween(this.nextButton, 200, { scale: 0.6, offset: 600 }, Phaser.Math.Easing.Quadratic.Out),
                    ],
            }
        );

        this.lightString = new LightString(this);
        this.updateLightsLeftLabel();
    }

    addBrightHouse()
    {
        let randHouse = Phaser.Math.Between(1, 12);
        this.currentHouseNumber = randHouse;

        this.largeHouse = ABCyaPhaser.Images.addImage(this.scale.width / 2, this.scale.height - 10, "house" + randHouse + "_light", this).setOrigin(0.5, 1);
    }

    addDarkHouse()
    {
        this.largeHouse.setFrame("house" + this.currentHouseNumber + "_dark");

        this.playAgainButton = this.add.container(this.scale.width / 2 + 430, this.scale.height / 2 + 220);
        const playAgainBtnBg = ABCyaPhaser.Images.addImage(0,0,LocalizationUIAssets._play_again, this.playAgainButton, ABCyaPhaser.Images.LOCALIZATION_ATLAS);
        ABCyaPhaser.Container.setContainerInteractive(this.playAgainButton);

        const playAgainBtnText = ABCyaPhaser.Text.addText(0,0, 24, 0xffffff, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString("play_again_button"), this.playAgainButton, true).setOrigin(0.5);
        ABCyaPhaser.Text.resizeFontToFitWidth(playAgainBtnText, this.playAgainButton.getBounds().width - 10, this.playAgainButton.getBounds().height, 100);

        ABCyaPhaser.Buttons.convertToButton(this.playAgainButton, {onClick: ()=>{
          ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
          this.replayGame();
        }}).setScale(0.6).setDepth(10);

        this.tweens.timeline(
            {
                tweens:
                    [
                        ABCyaPhaser.Tweens.createTween(this.playAgainButton, 500, { scale: 1, offset: 100 }, Phaser.Math.Easing.Quadratic.Out),
                        ABCyaPhaser.Tweens.createTween(this.playAgainButton, 200, { scale: 0.6, offset: 600 }, Phaser.Math.Easing.Quadratic.Out),
                    ],
            }
        );

        //hide label
        this.lightsLeftLabel.alpha = 0;
    }

    showMusicDialog()
    {
        this.input.removeAllListeners();
        this.background.removeAllListeners();

        this.nextButton.destroy();

        this.musicDialog = new MusicDialog(this, 0, 0);
        this.musicDialog.guitarButton.on(ABCyaPhaser.Buttons.Events.ButtonEvents.CLICK, this.startMusicGuitar, this);
        this.musicDialog.pianoButton.on(ABCyaPhaser.Buttons.Events.ButtonEvents.CLICK, this.startMusicKeyboard, this);
    }

    startMusicGuitar()
    {
        this.musicDialog.merryChristmas.destroyLightString();
        this.musicDialog.destroy();

        this.addDarkHouse();

        this.music = ABCyaPhaser.Audio.createSound(this);
        ABCyaPhaser.Audio.playSound(SoundAssetKeys._jingle_bells_guitar, this.music, 1, true);

        this.startAlternatingSequences();

        new Snow(this);
    }

    startMusicKeyboard()
    {
        this.musicDialog.merryChristmas.destroyLightString();
        this.musicDialog.destroy();

        this.addDarkHouse();

        this.music = ABCyaPhaser.Audio.createSound(this);
        ABCyaPhaser.Audio.playSound(SoundAssetKeys._jingle_bells_piano, this.music, 1, true);

        this.startAlternatingSequences();

        new Snow(this);
    }

    pressDown(pointer)
    {
        this.lightString.startNewString(pointer.worldX, pointer.worldY);

        this.updateLightsLeftLabel();

        if (this.lightString.lightsAdded >= gameData.lightsEarned)
        {
            // can't add any more lights, disable listeners
            this.background.removeAllListeners();
            this.input.once(Phaser.Input.Events.POINTER_UP, this.showMusicDialog, this);
        }
    }

    updateLightsLeftLabel()
    {
        let lightsLeft = gameData.lightsEarned - this.lightString.lightsAdded;

        if (lightsLeft < 0)
        {
            lightsLeft = 0;
        }
        this.lightsLeftLabel.text = ABCyaPhaser.Localization.instance.getLocalizedString("lights_left") +" " + lightsLeft;
    }

    pressMove(pointer)
    {
        if (pointer.isDown)
        {
            this.lightString.drawLineTo(pointer.worldX, pointer.worldY);

            if (this.lightString.lightsAdded >= gameData.lightsEarned)
            {
                this.background.removeAllListeners();
                this.input.once(Phaser.Input.Events.POINTER_UP, this.showMusicDialog, this);
            }

            this.updateLightsLeftLabel();
        }
    }

    async startAlternatingSequences()
    {
        if (!this.lightString.active) return;
        await this.lightString.lightSequence1(800, 4000);
        if (!this.lightString.active) return;
        await this.lightString.lightSequence2(40, this.lightString.lightsAdded * 40);
        if (!this.lightString.active) return;
        await this.lightString.lightSequence3(50, LIGHT_SEQUENCE_DIRECTIONS.backwards, this.lightString.lightsAdded * 50);
        if (!this.lightString.active) return;
        await this.lightString.lightSequence4(200, 3200);
        if (!this.lightString.active) return;
        await this.lightString.lightSequence5(300, 4800);
        if (!this.lightString.active) return;

        await this.startAlternatingSequences();
    }

    replayGame()
    {
        this.time.removeAllEvents();
        this.tweens.killAll();

        this.music.destroy();

        if (gameData.isMathVersion)
        {
            this.scene.start(SelectLevel.KEY);
        }
        else
        {
            this.scene.start(DrawLightsInstructions.KEY);
        }
    }
}